import React from 'react';
import { getCollisions, checkIfHasCollided } from './check-collisions';
import updateTargetings from './update-targetings';
import { ALLOWED_BLOCK_TYPES } from '../../constants';
import { PB_TYPE_BANNER } from './constants';
import getComponent from './getComponent';

const checkCanInjectBanner = (maxRepetitions, total) => {
  if (!maxRepetitions) return true;
  return total < maxRepetitions;
};

const injectTextblockBanners = ({ componentName, parsedTextBlock, bannerContext }) => {
  const {
    bannerCounters,
    banners,
    siblings,
    pbOptions,
    bannerPositionCounter,
    blockTracker
  } = bannerContext;
  const [collidedWithPrevious, collidedWithNext] = getCollisions(componentName, siblings);
  const updatedBlock = [];
  const { length: blocksLength } = parsedTextBlock;

  parsedTextBlock.forEach((block, blockIndex) => {
    const { type, props: { children: paragraphContent } = {} } = block;
    let hasBanner = false;
    const shouldCount = ALLOWED_BLOCK_TYPES.includes(type);
    if (!paragraphContent || typeof type !== 'string') {
      return addBlock(block, blockTracker, updatedBlock);
    }

    banners.forEach(banner => {
      const { name, settings, type: typeToCheck } = banner;
      const { repeatEvery, maxRepetitions } = settings;

      const { total, paragraphCounter, insertionPoint } = bannerCounters[name];
      const canInsertAfterPreviousBlock =
        !blockTracker.lastBlockType || ALLOWED_BLOCK_TYPES.includes(blockTracker.lastBlockType);

      const hasCollided =
        !canInsertAfterPreviousBlock ||
        checkIfHasCollided(blockIndex, blocksLength, collidedWithPrevious, collidedWithNext);
      const canInjectBanner = checkCanInjectBanner(maxRepetitions, total);

      if (canInjectBanner && paragraphCounter === insertionPoint) {
        if (hasBanner || hasCollided) {
          bannerCounters[name].insertionPoint += 1;
          bannerCounters[name].paragraphCounter += 1;
          return;
        }

        const bannerWithTargetings = repeatEvery
          ? updateTargetings(banner, bannerPositionCounter.counter)
          : banner;
        const bannerKey = `${bannerWithTargetings.settings.targetings}-${paragraphCounter}`;
        const updatedBanner = {
          ...pbOptions,
          ...bannerWithTargetings.settings,
          name
        };
        const Component = getComponent(typeToCheck);
        if (Component) updatedBlock.push(<Component key={bannerKey} {...updatedBanner} />);

        bannerCounters[name].insertionPoint += repeatEvery;
        bannerCounters[name].total += 1;
        hasBanner = true;
        if (repeatEvery && typeToCheck === PB_TYPE_BANNER) bannerPositionCounter.counter += 1;
      }

      bannerCounters[name].paragraphCounter += shouldCount ? 1 : 0;
    });

    return addBlock(block, blockTracker, updatedBlock);
  });

  return updatedBlock;
};

const addBlock = (block, blockTracker, updatedBlock) => {
  // eslint-disable-next-line no-param-reassign
  if (block.type) blockTracker.lastBlockType = block.type;
  return updatedBlock.push(block);
};

export default injectTextblockBanners;
